module.exports = __webpack_public_path__ + "static/media/scroll-up.bb73d8c1.svg";